import React from "react";
import { Link } from "react-router-dom";
import { GraduationCap, Heart, Lightbulb, ArrowRight } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

export default function About() {
  const { t, lang } = useLanguage();

  const values = [
    {
      icon: GraduationCap,
      title_no: "Pedagogisk fundert",
      title_en: "Pedagogically grounded",
      text_no:
        "Alle ressurser er bygget på forskning og 15+ års erfaring som sertifisert barnepedagog.",
      text_en:
        "All resources are built on research and 15+ years of experience as a certified child educator.",
    },
    {
      icon: Heart,
      title_no: "Laget med kjærlighet",
      title_en: "Made with love",
      text_no:
        "Vi designer for ekte familier - varme, vakre og praktiske løsninger som faktisk fungerer.",
      text_en:
        "We design for real families - warm, beautiful, and practical solutions that actually work.",
    },
    {
      icon: Lightbulb,
      title_no: "Enkelhet i sentrum",
      title_en: "Simplicity at heart",
      text_no:
        "Mindre kaos, mer ro. Våre PDF-er gir struktur uten å være rigide eller overveldende.",
      text_en:
        "Less chaos, more calm. Our PDFs give structure without being rigid or overwhelming.",
    },
  ];

  return (
    <div>
      {/* Hero */}
      <section className="bg-[#F9F8F6] border-b border-[#E5E2DC]">
        <div className="max-w-5xl mx-auto px-6 md:px-10 lg:px-16 py-20 md:py-32">
          <div className="flex items-center gap-3 mb-6">
            <span className="w-8 h-px bg-[#D97B66]"></span>
            <span className="text-xs uppercase tracking-[0.25em] text-[#6B726C] font-medium">
              {t("about_eyebrow")}
            </span>
          </div>
          <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl tracking-tight font-light text-[#2C302E] leading-[1.05]">
            {lang === "en"
              ? "Beautiful resources, "
              : "Vakre ressurser, "}
            <em className="not-italic font-medium text-[#D97B66]">
              {lang === "en" ? "thoughtfully made." : "laget med omtanke."}
            </em>
          </h1>
          <p className="mt-8 text-lg md:text-xl text-[#6B726C] leading-relaxed max-w-3xl">
            {t("about_text")}
          </p>
        </div>
      </section>

      {/* Values */}
      <section className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16 py-20 md:py-32">
        <div className="grid md:grid-cols-3 gap-8 md:gap-12">
          {values.map((v, i) => (
            <div key={i} className="space-y-4">
              <div className="w-12 h-12 rounded-full bg-[#8BA896]/15 flex items-center justify-center">
                <v.icon className="w-5 h-5 text-[#8BA896]" strokeWidth={1.5} />
              </div>
              <h3 className="font-heading text-xl md:text-2xl text-[#2C302E] font-medium">
                {lang === "en" ? v.title_en : v.title_no}
              </h3>
              <p className="text-[#6B726C] leading-relaxed">
                {lang === "en" ? v.text_en : v.text_no}
              </p>
            </div>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="bg-[#2C302E] text-white py-20 md:py-32">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="font-heading text-3xl md:text-5xl tracking-tight font-light leading-tight">
            {lang === "en"
              ? "Discover what fits your family."
              : "Finn det som passer din familie."}
          </h2>
          <Link
            to="/butikk"
            data-testid="about-cta-shop"
            className="mt-10 inline-flex items-center gap-3 bg-[#D97B66] hover:bg-[#C66A55] text-white rounded-full pl-7 pr-3 py-3 font-medium"
          >
            {t("hero_cta_shop")}
            <span className="bg-white/15 rounded-full p-2">
              <ArrowRight className="w-4 h-4" strokeWidth={2} />
            </span>
          </Link>
        </div>
      </section>
    </div>
  );
}
